var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-records",
    attrs: {
      "id": "allrecords",
      "data-tilda-export": "yes",
      "data-hook": "blocks-collection-content-node",
      "data-tilda-project-id": "1933100",
      "data-tilda-page-id": "14196891",
      "data-tilda-page-alias": "background",
      "data-tilda-formskey": "00da022453d7435b7731ad57b717c0d2"
    }
  }, [_c('div', {
    staticClass: "r t-rec",
    staticStyle: {},
    attrs: {
      "id": "rec241229390",
      "data-animationappear": "off",
      "data-record-type": "396"
    }
  }, [_c('div', {
    staticClass: "t396"
  }, [_c('div', {
    staticClass: "t396__artboard",
    attrs: {
      "data-artboard-recid": "241229390",
      "data-artboard-height": "720",
      "data-artboard-height-res-640": "740",
      "data-artboard-height-res-480": "960",
      "data-artboard-height-res-320": "910",
      "data-artboard-height_vh": "100",
      "data-artboard-height_vh-res-640": "100",
      "data-artboard-height_vh-res-320": "100",
      "data-artboard-valign": "top",
      "data-artboard-ovrflw": ""
    }
  }, [_c('div', {
    staticClass: "t396__carrier",
    attrs: {
      "data-artboard-recid": "241229390"
    }
  }), _c('div', {
    staticClass: "t396__filter",
    attrs: {
      "data-artboard-recid": "241229390"
    }
  }), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531534 t-animate",
    attrs: {
      "data-elem-id": "1603208531534",
      "data-elem-type": "image",
      "data-field-top-value": "296",
      "data-field-top-res-960-value": "296",
      "data-field-top-res-640-value": "316",
      "data-field-top-res-480-value": "86",
      "data-field-top-res-320-value": "85",
      "data-field-left-value": "-549",
      "data-field-left-res-960-value": "-459",
      "data-field-left-res-640-value": "-199",
      "data-field-left-res-480-value": "-190",
      "data-field-left-res-320-value": "-130",
      "data-field-width-value": "301",
      "data-field-width-res-480-value": "140",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeinright",
      "data-animate-duration": "1",
      "data-animate-delay": "0.3",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild3662-3261-4863-b133-303530633966__follower2.svg",
      "imgfield": "tn_img_1603208531534"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531540 t-animate",
    attrs: {
      "data-elem-id": "1603208531540",
      "data-elem-type": "image",
      "data-field-top-value": "294",
      "data-field-top-res-960-value": "294",
      "data-field-top-res-640-value": "314",
      "data-field-top-res-480-value": "85",
      "data-field-left-value": "280",
      "data-field-left-res-960-value": "258",
      "data-field-left-res-640-value": "238",
      "data-field-left-res-480-value": "100",
      "data-field-width-value": "300",
      "data-field-width-res-480-value": "140",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeinleft",
      "data-animate-duration": "1",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild6536-3462-4561-a563-636163643534__greenman.svg",
      "imgfield": "tn_img_1603208531540"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531544 t-animate",
    attrs: {
      "data-elem-id": "1603208531544",
      "data-elem-type": "image",
      "data-field-top-value": "-10",
      "data-field-top-res-640-value": "-90",
      "data-field-top-res-480-value": "-20",
      "data-field-left-value": "-470",
      "data-field-left-res-640-value": "-260",
      "data-field-left-res-480-value": "-145",
      "data-field-width-value": "99",
      "data-field-width-res-480-value": "50",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeindown",
      "data-animate-duration": "1",
      "data-animate-delay": "0.3",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild3133-3536-4136-b263-396535633937__lamp.svg",
      "imgfield": "tn_img_1603208531544"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531548 t-animate",
    attrs: {
      "data-elem-id": "1603208531548",
      "data-elem-type": "image",
      "data-field-top-value": "5",
      "data-field-top-res-640-value": "-10",
      "data-field-top-res-480-value": "5",
      "data-field-left-value": "316",
      "data-field-left-res-640-value": "186",
      "data-field-left-res-480-value": "110",
      "data-field-width-value": "591",
      "data-field-width-res-480-value": "300",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "zoomin",
      "data-animate-duration": "3",
      "data-animate-scale": "0.9",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild6363-3564-4433-a138-333538303735__stars.svg",
      "imgfield": "tn_img_1603208531548"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531551 t-animate",
    attrs: {
      "data-elem-id": "1603208531551",
      "data-elem-type": "image",
      "data-field-top-value": "320",
      "data-field-top-res-960-value": "320",
      "data-field-top-res-640-value": "340",
      "data-field-top-res-480-value": "84",
      "data-field-left-value": "570",
      "data-field-left-res-960-value": "487",
      "data-field-left-res-640-value": "354",
      "data-field-left-res-480-value": "175",
      "data-field-width-value": "254",
      "data-field-width-res-480-value": "127",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeinright",
      "data-animate-duration": "1",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild6239-3938-4537-a537-633933656464__union.svg",
      "imgfield": "tn_img_1603208531551"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531555 t-animate",
    attrs: {
      "data-elem-id": "1603208531555",
      "data-elem-type": "image",
      "data-field-top-value": "215",
      "data-field-top-res-640-value": "215",
      "data-field-top-res-480-value": "80",
      "data-field-top-res-320-value": "80",
      "data-field-left-value": "-347",
      "data-field-left-res-640-value": "-237",
      "data-field-left-res-480-value": "5",
      "data-field-left-res-320-value": "29",
      "data-field-width-value": "106",
      "data-field-width-res-480-value": "80",
      "data-field-width-res-320-value": "60",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "zoomin",
      "data-animate-duration": "1",
      "data-animate-scale": "0.9",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild6363-3265-4162-b132-656162323033__clock.svg",
      "imgfield": "tn_img_1603208531555"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208531559 t-animate",
    attrs: {
      "data-elem-id": "1603208531559",
      "data-elem-type": "image",
      "data-field-top-value": "303",
      "data-field-top-res-960-value": "303",
      "data-field-top-res-640-value": "323",
      "data-field-top-res-480-value": "77",
      "data-field-top-res-320-value": "75",
      "data-field-left-value": "-318",
      "data-field-left-res-960-value": "-278",
      "data-field-left-res-640-value": "-338",
      "data-field-left-res-480-value": "-100",
      "data-field-left-res-320-value": "-60",
      "data-field-width-value": "323",
      "data-field-width-res-480-value": "160",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeinright",
      "data-animate-duration": "1",
      "data-animate-delay": "0.1",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild3164-6363-4530-a138-366434383662__follower1.svg",
      "imgfield": "tn_img_1603208531559"
    }
  })])]), _c('div', {
    staticClass: "t396__elem tn-elem tn-elem__2412293901603208549570 t-animate",
    attrs: {
      "data-elem-id": "1603208549570",
      "data-elem-type": "image",
      "data-field-top-value": "-20",
      "data-field-top-res-640-value": "-65",
      "data-field-top-res-480-value": "-20",
      "data-field-left-value": "-395",
      "data-field-left-res-640-value": "-185",
      "data-field-left-res-480-value": "-105",
      "data-field-width-value": "69",
      "data-field-width-res-480-value": "30",
      "data-field-axisy-value": "top",
      "data-field-axisx-value": "center",
      "data-field-container-value": "grid",
      "data-field-topunits-value": "px",
      "data-field-leftunits-value": "px",
      "data-field-heightunits-value": "",
      "data-field-widthunits-value": "px",
      "data-animate-style": "fadeindown",
      "data-animate-duration": "1",
      "data-animate-delay": "0.4",
      "data-animate-distance": "100",
      "data-animate-mobile": "y"
    }
  }, [_c('div', {
    staticClass: "tn-atom"
  }, [_c('img', {
    staticClass: "tn-atom__img t-img",
    attrs: {
      "data-original": "images/tilda/subscription-empty-list/tild3133-3536-4136-b263-396535633937__lamp.svg",
      "imgfield": "tn_img_1603208549570"
    }
  })])])])])])]);
}]

export { render, staticRenderFns }